
import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { FaRobot, FaBrain, FaEye, FaChartLine, FaComments, FaLightbulb, FaMicrochip, FaCogs, FaHeadset, FaUser, FaDatabase, FaSync, FaHdd, FaShieldAlt, FaChartPie, FaCloud, FaAws, FaCheckCircle, FaReact, FaCodeBranch, FaMobile, FaLaptopCode, FaLock, FaServer } from "react-icons/fa";
import OurNumbers from "./OurNumbers";

const CodeMasters = () => {
return (
    <Box sx={{ padding: "40px", maxWidth: "1200px", margin: "auto" }}>

        <Card
          sx={{
            background: "rgba(0, 0, 0, 0.9)",
            color: "white",
            borderRadius: "12px",
            padding: "30px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
            backdropFilter: "blur(15px)",
            textAlign: "center",
          }}
        >
          <CardContent>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
              Elevate Your Digital Solutions with Code Masters
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.9 }}>
              Harness the power of our expertise in Frontend Development, Backend Development, DevOps, and Security to build robust and scalable applications.
            </Typography>
          </CardContent>
        </Card>

        {/* Code Masters Services Section */}
      <Grid container spacing={3} sx={{ marginTop: "40px" }}>
        {aiServices.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={glassyCardStyle}>
              <Box sx={logoBox}>{service.icon}</Box>
              <Typography variant="h6" fontWeight="bold">
                {service.title}
              </Typography>
              <Typography variant="body2" sx={{ marginTop: "10px", color: "#222" }}>
                {service.description}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Statistics Section - Animated UX Grid */}
      
      <OurNumbers/>
    </Box>
  );
};

// Glassy Card Style
const glassyCardStyle = {
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  backdropFilter: "blur(10px)",
  minHeight: "220px",
};

// Stylish Number Presentation
const statsBoxStyle = {
  borderRadius: "10px",
  padding: "20px",
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
  backdropFilter: "blur(12px)",
  textAlign: "center",
  minWidth: "200px",
};

const logoBox = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "80px",
    height: "80px",
    borderRadius: "10px",
    backgroundColor: "rgb(211, 154, 158, 0.08)",
    marginBottom: "15px",
    boxShadow: "0 0 5px rgb(211, 154, 158), 0 0 10px rgb(211, 154, 158), 0 0 20px rgb(211, 154, 158)",
    fontSize: "2rem", // Adjust the font size to make the icon larger
};

// Expanded AI Services with Hot AI Topics
const aiServices = [
    {
        title: "Frontend Development",
        description: "Design intuitive and responsive user interfaces with cutting-edge frontend frameworks",
        icon: <FaReact />,
    },
    {
        title: "Secure Backend Development",
        description: "Build robust, scalable, and secure backend architectures to power modern applications.",
        icon: <FaServer />,
    },
    {
        title: "DevSecOps & Cloud Security",
        description: "Ensure security throughout the development lifecycle with DevSecOps best practices.",
        icon: <FaLock />,
    },


    {
        title: "Full-Stack Development",
        description: "Develop end-to-end applications with expertise in both frontend and backend technologies.",
        icon: <FaLaptopCode />,
    },
    {
        title: "Mobile App Development",
        description: "Create seamless and high-performing mobile applications for iOS and Android.",
        icon: <FaMobile />,
    },
    {
        title: "Automated Testing & Quality Assurance",
        description: "Implement automated testing strategies to ensure software reliability and efficiency.",
        icon: <FaCheckCircle />,
    },
    {
        title: "Code Security & Compliance",
        description: "Protect applications from vulnerabilities with secure coding practices and compliance adherence.",
        icon: <FaShieldAlt />,
    },
    {
        title: "Microservices & API Development",
        description: "Architect scalable microservices and well-documented APIs for modern applications.",
        icon: <FaCodeBranch />,
    },
];


export default CodeMasters;